'use strict';

/* globals define, config, $, socket, window, document, ajaxify */

define('boardApp', [
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js',
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/interact.js',
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/panzoom.js',
], function (Vue, interact, panzoom) {
	var BoardApp = {};

	BoardApp.isInitialized = false;

	BoardApp.init = function () {
		BoardApp.initApp();
		BoardApp.initZooming();
		BoardApp.initDraggable();
		BoardApp.setBoardHeight('#board');
	};

	BoardApp.initApp = function () {
		new Vue({
			el: '#board',
			data: {
				isBoardOwner: ajaxify.data.isBoardOwner,
			},
		});
	};

	BoardApp.initZooming = function () {
		var element = document.querySelector('.ib-board');

		BoardApp.isNoteTouchedPrev = false;

		BoardApp.panzoom = panzoom(element, {
			smoothScroll: true,
			maxZoom: 1.5,
			minZoom: 0.3,
			onTouch: function (e) {
				var isNoteTouched = ($(e.target).parents('.note').length > 0 || $(e.target).hasClass('note'));

				var hasNoteOnEdit = $('.edit-mode').length > 0;

				return !(isNoteTouched || hasNoteOnEdit);
			},
		});

		BoardApp.panzoom.on('transform', function (e) {
			var currentPosition = e.getTransform();

			if (currentPosition.x <= 0 && currentPosition.y <= 0) {
				return;
			}

			var xPos = currentPosition.x > 0 ? 0 : currentPosition.x;
			var yPos = currentPosition.y > 0 ? 0 : currentPosition.y;

			e.moveTo(xPos, yPos);
		});
	};

	BoardApp.setBoardHeight = function (element) {
		setHeightToEndOfPage(element);

		$(window).on('resize', function () {
			setHeightToEndOfPage(element);
		});
	};

	function setHeightToEndOfPage(element) {
		$(element).css('height', $(window).height() - $(element).offset().top);
	}

	BoardApp.waitForNoteId = function (element, callback) {
		var noteId = parseInt($(element).attr('data-id'), 10);

		if (noteId) {
			return callback(noteId);
		}

		setTimeout(function () {
			BoardApp.waitForNoteId(element, callback);
		}, 250);
	};

	BoardApp.initDraggable = function () {
		if (BoardApp.isInitialized) {
			return;
		}

		interact('.note')
			.draggable({
				modifiers: [
					interact.modifiers.snap({
						targets: [
							interact.createSnapGrid({ x: 20, y: 20 }),
						],
						range: Infinity,
						relativePoints: [{ x: 0, y: 0 }],
					}),
					interact.modifiers.restrictRect({
						restriction: '.ib-board',
						endOnly: true,
					}),
				],
				allowFrom: '.move-btn',
				inertia: true,

				onstart: function () {
					BoardApp.panzoom.pause();
				},

				onend: function (event) {
					var note = $(event.target);

					BoardApp.waitForNoteId(note, function (noteId) {
						socket.emit('plugins.ideasBoard.saveNotePosition', {
							noteId: noteId,
							x: parseInt(note.css('left'), 10),
							y: parseInt(note.css('top'), 10),
						});
					});

					BoardApp.panzoom.resume();
				},

				onmove: function dragMoveListener(event) {
					var target = $(event.target);

					target.css('left', parseInt(target.css('left') || 0, 10) + event.dx + 'px');
					target.css('top', parseInt(target.css('top') || 0, 10) + event.dy + 'px');
				},
			});

		$.autoExpand = function () {
			setTimeout(function () {
				$('textarea.autoExpand').each(function () {
					this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
				}).on('input', function () {
					this.style.height = 'auto';
					this.style.height = (this.scrollHeight) + 'px';
				});
			}, 50);
		};

		BoardApp.isInitialized = true;
	};

	return BoardApp;
});
